import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private currentVersion = '';
  baseUrl: string;
  url: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.urlAddress + '/api/';
  }

  public initVersionCheck() {
    interval(3000).pipe( // check every 60 seconds
      switchMap(() => this.http.get<any>('version.json'))
    ).subscribe(version => {
      this.currentVersion = version.currVersion;
      console.log(this.currentVersion)
      console.log(version.refreshTimes)
      if (version.refreshTimes < 2 || (this.currentVersion && this.currentVersion !== version.version)) {
        //console.log('New version detected. Reloading...');
        this.url = this.baseUrl + 'Login/UpdateVersionSettings?newVersionVal=' + version.version;
        this.LoginData_Service().subscribe(res => {
          window.location.reload(true); // Force reload
       });
      }
    });
  }

  LoginData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }
}
